import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

import { PiV2OppInvestmentComponent } from './pi-v2-opp-investment/pi-v2-opp-investment.component';
import { PiV2OppPerformanceComponent } from './pi-v2-opp-performance/pi-v2-opp-performance.component';
import { PiV2OppResumenFinancialComponent } from './pi-v2-opp-resumen-financial/pi-v2-opp-resumen-financial.component';
import { PiV2OppSchemeComponent } from './pi-v2-opp-scheme/pi-v2-opp-scheme.component';
import { PiV2OppUpdatesComponent } from './pi-v2-opp-updates/pi-v2-opp-updates.component';
import { PiV2OppSimulatorComponent } from './pi-v2-opp-simulator/pi-v2-opp-simulator.component';
import { PiV2OppDocumentsComponent } from './pi-v2-opp-documents/pi-v2-opp-documents.component';

import { ProjectV2 } from '@app/interfaces';
export interface Section { 
  id: number;
  title: string;
  open: boolean;
}

@Component({
  selector: 'mnf-pi-v2-opp-collapse',
  standalone: true,
  imports: [
    CommonModule, MatExpansionModule,
    PiV2OppInvestmentComponent,
    PiV2OppPerformanceComponent,
    PiV2OppResumenFinancialComponent,
    PiV2OppSchemeComponent,
    PiV2OppUpdatesComponent,
    PiV2OppSimulatorComponent,
    PiV2OppDocumentsComponent
  ],
  templateUrl: './pi-v2-opp-collapse.component.html',
  styleUrl: './pi-v2-opp-collapse.component.scss'
})
export class PiV2OppCollapseComponent {

  panelOpenState = false;

  @Input() item: Section;
  @Input() infoProject: ProjectV2;

}
